import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api.service";
import { Asset } from "types/asset";
import { useAlert } from "hooks/alerts/useAlert";

export default function useCreateAsset() {
  const navigate = useNavigate();
  const { alertSuccess } = useAlert();

  const create = useCallback(
    (asset: Partial<Asset>) => {
      return api.post<Asset>("/assets", { asset }).then(() => {
        alertSuccess("Asset registered.");
        navigate("/assets", { state: { refreshAssets: true } });
      });
    },
    [navigate, alertSuccess]
  );

  return {
    create,
  };
}
